<template>
  <div class="login">
    <img
      src="../assets/imgs/loginTopBg.png"
      alt=""
      class="loginTopBg"
    >
    <div class="loginForm">
      <mt-field
        type="tel"
        placeholder="手机号"
        v-model="phoneNum"
        v-focus
        :attr="{ maxlength: 11 }"
        style="background:#DDE2EB;margin-bottom:0.4rem; border-radius:0.44rem;height:0.8rem;"
      ></mt-field>
      <mt-field
        placeholder="验证码"
        type="tel"
        class="code"
        v-model="code"
        :attr="{ maxlength: 4 }"
        style="background:#DDE2EB;margin-bottom:0.4rem; border-radius:0.44rem;height:0.8rem;"
      >

        <span @click.stop="sendCode">{{ codeStr }}</span>

      </mt-field>
      <mt-button
        type="default"
        class="loginBtn"
        :disabled='enablelogin'
        @click="register"
      >登录</mt-button>
    </div>
  </div>
</template>

<script>
import { GetSmsCode, ToLogin } from '../../src/api/Api'
import { MessageBox, Toast } from 'mint-ui'
import Vue from 'vue'
let validatePhone = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/

// 注册一个全局自定义指令 v-focus
Vue.directive('focus', {
  // 当登录元素插入到 DOM 中。
  inserted: function (el, binding) {
    // 聚焦元素
    console.log('@@@@@')
    el.focus()
  }
})
export default {
  name: 'login',
  data () {
    return {
      myPageTit: '登录',
      codeStr: '获取验证码',
      phoneNumState: '',
      codeState: '',
      phoneNum: '',
      isSending: false,
      code: '',
      enablelogin: true,
      flag: true,
      userInfo: {
        userName: '',
        openId: ''
      },
      baseUrl: window.baseapi.baseApiUrl
    }
  },
  watch: {
    code: function (val, oldval) {
      if (val !== '') {
        this.enablelogin = false
      } else {
        this.enablelogin = true
      }
    },
    phoneNum: function (val, oldval) {
      if (val !== '' && validatePhone.test(val) && this.code !== '') {
        this.enablelogin = false
      } else {
        this.enablelogin = true
      }
    }
  },
  created () {
    console.log('当前时间戳' + this.dateFormat())
    console.log('这是登录页openid：' + localStorage.getItem('openid'))
  },
  methods: {
    dateFormat () {
      var date = new Date()
      var year = date.getFullYear()
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      // 拼接
      return (
        year +
        '-' +
        month +
        '-' +
        day +
        ' ' +
        hours +
        ':' +
        minutes +
        ':' +
        seconds
      )
    },
    sendCode () {
      if (!this.phoneNum || !validatePhone.test(this.phoneNum)) {
        Toast('请输入有效的手机号')
      } else {
        this.getSMSCode()
      }
    },
    // （倒计时验证）
    startTime (time) {
      var timer = setInterval(() => {
        time--
        if (time === 0) {
          this.flag = true
          this.codeStr = '发送验证码'
          clearInterval(timer)
        } else {
          this.codeStr = time + 's后重新发送'
          this.flag = false // 防止用户连续点击
        }
      }, 1000)
    },
    getSMSCode () {
      if (this.flag) {
        this.startTime(60)
        this.isSending = false
        // GetSmsCode({
        //   mobile: _this.phoneNum
        // }).then(res => {
        //   if (res.data.code === 200) {
        //     _this.enablelogin = false
        //     Toast('验证码已发送至手机')
        //   } else {
        //     Toast('验证码未发送成功，请重试')
        //   }
        // })
        this.$axios({
          method: 'get',
          url: this.baseUrl + '/safeStudy/login/message',
          params: { mobile: this.phoneNum }
        }).then(res => {
          if (res.data.code === 200) {
            this.enablelogin = false
            Toast('验证码已发送至手机')
          } else {
            Toast('验证码未发送成功，请重试')
          }
        })
      } else {
        return false
      }
    },
    register () {
      // MessageBox({
      //   title: '培训协议',
      //   message:
      //     '1.协议的范围<br>1.1 本协议是由您与本站之间关于使用相关网络服务所订立的协议。<br><br>1.2 本协议内容同时包括个人信息相关保护政策，且您在使用某一特定服务时，该服务可能会另有单独的协议、相关业务规则表示同意，即为本协议不可分割的组成部分，您应当全部遵守。<br><br>2.账号的注册和使用<br>2.1 您在使用本站提供的网络服务时可能需要注册一个账号，当您注册成功后，您有权使用您设置或确认的邮箱、手机号码、微博、博客账户名称及您设置的密码登录。',
      //   showCancelButton: true,
      //   confirmButtonText: '同意',
      //   cancelButtonText: '取消'
      // }).then(action => {
      // if (action === 'confirm') {
      if (!this.phoneNum || !validatePhone.test(this.phoneNum)) {
        Toast('请输入有效的手机号!')
        return false
      }
      if (this.code.length !== 4) {
        Toast('验证码为4位数字格式!')
        return false
      }
      // 确认的回调
      var _this = this
      var opId = localStorage.getItem('openid')
      if (!_this.enablelogin) {
        if (opId === '' || opId === null || opId === undefined) {
          this.$router.push({
            path: '/'
          })
          return false
        }
        ToLogin({
          mobile: _this.phoneNum,
          code: _this.code,
          openid: opId
        }).then(res => {
          if (res.data.code === 200) {
            Toast('登录成功')
            console.log(res);
            sessionStorage.setItem('token', res.data.data[0].token)
            // sessionStorage.setItem('platform', res.data.data[0].platform) // 继续教育0  专项学习1 道路运输 2
            this.$store.dispatch('SetToken', res.data.data[0].token)
            this.$store.dispatch('SetStuId', res.data.data[0].uid)
            // this.$store.dispatch('SetPlatform', res.data.data[0].platform)
            this.$store.dispatch(
              'SetProfessionId',
              res.data.data[0].ProfessionId
            ) // 货运1  客运2 危险3 出租5
            sessionStorage.setItem('userName', res.data.data[0].StuName)
            sessionStorage.setItem('sex', res.data.data[0].Sex)
            sessionStorage.setItem('phone', res.data.data[0].Phone)
            sessionStorage.setItem('photo', res.data.data[0].PhotoImage)
            sessionStorage.setItem('userId', res.data.data[0].uid)
            sessionStorage.setItem('companyId', res.data.data[0].Company)
            sessionStorage.setItem(
              'professionId',
              res.data.data[0].ProfessionId
            )
            sessionStorage.setItem(
              'professionName',
              res.data.data[0].ProfessionName
            )
            sessionStorage.setItem('IdCard', res.data.data[0].IdCard)
            sessionStorage.setItem(
              'driverNumber',
              res.data.data[0].driverNumber
            )
            sessionStorage.setItem('register', res.data.data[0].register)
            sessionStorage.setItem(
              'CertificateNo',
              res.data.data[0].Certificate
            )
            sessionStorage.setItem('companyName', res.data.data[0].CompanyName)

            this.$router.push({
              path: '/'
            })
          } else {
            Toast('验证码错误或已过期，请重新输入')
          }
        })
      } else {
        Toast('验证失败')
      }
      // } else {
      //   return false
      // }
      // })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Login.vue